// extracted by mini-css-extract-plugin
export var resizer = "_du-0";